import React, { useState } from "react";
import { Box, Button, CircularProgress, Stack, TextField, Typography, Alert } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { toast } from "react-toastify";
import { apiPost } from "../../api/client";
import { endpoints } from "../../api/endpoints";
import { extractErrorMessage } from "../../utils/errorMessage";

export default function ForgotPasswordNew() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email");
    setLoading(true);
    try {
      await apiPost(endpoints.auth.forgotPassword, { email });
      setSent(true);
    } catch (err) {
      toast.error(extractErrorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 420 }}>
        <Button component={Link} to="/login" startIcon={<ArrowBackOutlinedIcon />} sx={{ mb: 3, color: "text.secondary" }}>
          Back to sign in
        </Button>

        <Box
          sx={{
            width: 56, height: 56, borderRadius: 3,
            background: "linear-gradient(135deg, #EDE8FA 0%, #F4EDFA 100%)",
            color: "primary.main",
            display: "flex", alignItems: "center", justifyContent: "center",
            mb: 3,
          }}
        >
          <MarkEmailReadOutlinedIcon sx={{ fontSize: 28 }} />
        </Box>

        {sent ? (
          <>
            <Typography sx={{ fontSize: "1.75rem", fontWeight: 800, mb: 1 }}>Check your inbox</Typography>
            <Typography sx={{ fontSize: 14, color: "text.secondary", mb: 3 }}>
              If an account exists for <strong>{email}</strong>, we've sent a password reset link. The link expires in 30 minutes.
            </Typography>
            <Alert severity="info" sx={{ mb: 3 }}>
              Didn't receive it? Check your spam folder, or contact HR.
            </Alert>
            <Button fullWidth variant="contained" size="large" onClick={() => nav("/login")} sx={{ py: 1.5 }}>
              Return to sign in
            </Button>
          </>
        ) : (
          <>
            <Typography sx={{ fontSize: "1.75rem", fontWeight: 800, mb: 1 }}>Forgot password?</Typography>
            <Typography sx={{ fontSize: 14, color: "text.secondary", mb: 3 }}>
              Enter your registered email and we'll send you a reset link.
            </Typography>
            <Box component="form" onSubmit={submit}>
              <Stack spacing={2.5}>
                <TextField
                  fullWidth size="medium" type="email" label="Email address"
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  autoFocus autoComplete="email"
                />
                <Button type="submit" fullWidth variant="contained" size="large" disabled={loading} sx={{ py: 1.5 }}>
                  {loading ? <CircularProgress size={22} color="inherit" /> : "Send reset link"}
                </Button>
              </Stack>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
